import { useTranslation } from 'react-i18next';
import { Layout } from '../../components/Layout.js';

export function TermsPage() {
  const { t } = useTranslation('legal');

  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">{t('terms.title')}</h1>
        <p className="text-sm text-neutral-500 mb-8">{t('terms.last_updated')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h1')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p1')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h2')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p2')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h3')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p3')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h4')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p4')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h5')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p5')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h6')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p6')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h7')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p7')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h8')}</h2>
        <p className="text-neutral-300 leading-relaxed">{t('terms.p8')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('terms.h9')}</h2>
        <p className="text-neutral-300 leading-relaxed">legal@boletra.com</p>
      </article>
    </Layout>
  );
}
